module.exports = __webpack_public_path__ + "static/img/user-success-icon.c80bcd47.png";